"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _makeStyles.default;
  }
});

var _makeStyles = _interopRequireDefault(require("./makeStyles"));


/*****************
 ** WEBPACK FOOTER
 ** ./~/@material-ui/styles/makeStyles/index.js
 ** module id = 129
 ** module chunks = 0
 **/